<h2 [sxc-toolbar]="toolbarHelperSvc.toolbarMain(categoryInfo().EntityId)">
  @if (title() === downloadCategory.Driver) {
    Speedgoat I/O Blockset & Tools
  } @else if (title() === downloadCategory.Support) {
    Support
  } 
</h2>

@if (items().length > 0) {
  <div [class.driver-class]="title() !== downloadCategory.Support">
      <span [innerHTML]="notesBefore()" [sxc-toolbar]="toolbarHelperSvc.toolbarMain(categoryInfo().EntityId)"></span>
      
      <table class="table table-hover">
        <tbody>
        @for (item of items(); track item.Id) {
          <tr>
            <td [sxc-toolbar]="toolbarHelperSvc.toolbarEditDownload(item.Id, item.Title, item.EntityGuid)">
              <a [href]="item.DownloadUrl" target="{{ item.Target }}">
                {{ item.Title }} 
              </a>
            </td>
          </tr>
        }
      </tbody>
    </table>
    
    <span [innerHTML]="notesAfter()"></span>
</div>
}

@if (items().length === 0) {
  <p>No Downloads</p>
}